

if ($('#page-onair').length) page_onair();


function page_onair() {


    $.ajax('/news/season2-onair', {
        dataType: 'json',
        cache: false
    })
    .done(function (data) {
        show_onair_list(data);
    });

}

function show_onair_list(data) {

    // 放送局単体
    var compo_onair = {
        template: '#compo-onair',
        props: {
            onairData: Object
        },
        computed: {
            day: function () {
                return this.onairData.day.replace(/(\d+)/g, '<strong>$1</strong>');
            },
            time: function () {
                var str = this.onairData.time.replace(/(\d+)/g, '<strong>$1</strong>');
                return str.replace(/毎週(.+?)曜/, '毎週<strong>$1</strong>曜');
            }
        }
        // function convert_onair( $onair ){
        //     // 数字を大きく
        //     $onair['day'] = preg_replace( '/(\d+)/', '<strong>\1</strong>', $onair['day'] );
        //     $onair['time'] = preg_replace( '/(\d+)/', '<strong>\1</strong>', $onair['time'] );
        //     // 曜日を大きく
        //     $onair['time'] = preg_replace( '/毎週(.+?)曜/', '毎週<strong>\1</strong>曜', $onair['time'] );

        //     return $onair;
        // }

    };

    var onair_vue = new Vue({
        el: '#app-onair',
        data: data.acf,
        components: {
            'onair-item': compo_onair
        }
    })

}